import {Popover} from 'bootstrap';

export default class BootstrapPopover {
    public constructor(element: Element) {
        // tslint:disable-next-line:no-unused-expression
        new Popover(element as HTMLElement);
    }
}
